export const IOS_STORE_URL =
  process.env.REACT_APP_IOS_STORE_URL ||
  'https://apps.apple.com/us/app/sporti-app/id6775211968?utm_source=sporti_website';

export const ANDROID_STORE_URL =
  process.env.REACT_APP_ANDROID_STORE_URL ||
  'https://play.google.com/store/apps/details?id=com.sporti.app&utm_source=sporti_website';

// Custom URL scheme used to attempt opening the native app. Configurable via env
// since it is not documented elsewhere in this repo and must match the mobile apps.
export const APP_SCHEME = process.env.REACT_APP_APP_SCHEME || 'sporti';

// Android package name (must match assetlinks.json and the installed app).
export const ANDROID_PACKAGE =
  process.env.REACT_APP_ANDROID_PACKAGE || 'com.sporti.app';

// App-link paths kept in sync with public/.well-known/apple-app-site-association
// and assetlinks.json. Any path matched here is treated as a deep link.
export const DEEP_LINK_PATHS = [
  '/referral/*',
  '/reset/*',
  '/listing/*',
  '/social/*',
  '/signin',
  '/signup',
  '/forgot-password',
  '/search',
  '/provider/claim/*',
  '/provider/unclaimed-profile'
];
